import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {DialogActions as RmwcDialogActions} from '@rmwc/dialog'
import '@rmwc/dialog/styles'

export const dialogActionsStyles = ({selector = '&&&'}) => css`
  ${selector} {
    padding: 2rem;
  }
`

const StyledRmwcDialogActions = styled(RmwcDialogActions)`
  ${dialogActionsStyles}
`

const DialogActions = ({children, ...otherProps}) => <StyledRmwcDialogActions {...otherProps}>{children}</StyledRmwcDialogActions>

DialogActions.propTypes = {
  children: PropTypes.any
}

export {DialogActions}
